var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuPlaylists(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_15173)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00183097 1C0.00183102 0.447715 0.449546 3.91405e-08 1.00183 8.74228e-08L19.0018 1.66103e-06C19.5541 1.70932e-06 20.0018 0.447717 20.0018 1C20.0018 1.55229 19.5541 2 19.0018 2L1.00183 2C0.449546 2 0.00183092 1.55228 0.00183097 1Z",
    fill: "#BB85FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00183 6L1.00183 6C0.449546 6 0.00183092 5.55228 0.00183097 5C0.00183102 4.44772 0.449546 4 1.00183 4L9.00183 4C9.55412 4 10.0018 4.44772 10.0018 5C10.0018 5.55229 9.55412 6 9.00183 6Z",
    fill: "#BB85FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00183105 9C0.00183105 8.44772 0.449546 8 1.00183 8H7.00183C7.55412 8 8.00183 8.44772 8.00183 9C8.00183 9.55228 7.55412 10 7.00183 10H1.00183C0.449546 10 0.00183105 9.55228 0.00183105 9Z",
    fill: "#BB85FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00183105 13C0.00183105 12.4477 0.449546 12 1.00183 12H4.00183C4.55412 12 5.00183 12.4477 5.00183 13C5.00183 13.5523 4.55412 14 4.00183 14H1.00183C0.449546 14 0.00183105 13.5523 0.00183105 13Z",
    fill: "#BB85FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.53 4.11833C12.8551 3.94431 13.2497 3.96338 13.5565 4.16795L19.5565 8.16795C19.8347 8.35342 20.0018 8.66565 20.0018 9C20.0018 9.33435 19.8347 9.64659 19.5565 9.83205L13.5565 13.8321C13.2497 14.0366 12.8551 14.0557 12.53 13.8817C12.2048 13.7077 12.0018 13.3688 12.0018 13V5C12.0018 4.63121 12.2048 4.29235 12.53 4.11833ZM14.0018 6.86852V11.1315L17.1991 9L14.0018 6.86852Z",
    fill: "#BB85FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_15173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    fill: "white",
    transform: "translate(0.00183105)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPlaylists);
export default __webpack_public_path__ + "static/media/menu-playlists.6c52666e90418baa3855593f5fefe16f.svg";
export { ForwardRef as ReactComponent };